const galleryImages = [
    { id: 1, img: "/assets/pic1.JPG", title: "Temple View" },
    { id: 2, img: "/assets/pic2.JPG", title: "Sacred Lamp" },
    { id: 3, img: "/assets/pic3.JPG", title: "Evening Pooja" },
    { id: 4, img: "/assets/pic4.JPG", title: "Temple Entrance" },
    { id: 5, img: "/assets/pic5.JPG", title: "Festival Lights" },
    { id: 6, img: "/assets/pic6.JPG", title: "Deepam" },
    { id: 7, img: "/assets/pic7.JPG", title: "Devotees" },
    { id: 8, img: "/assets/pic8.JPG", title: "Sanctum View" },
    { id: 9, img: "/assets/2.jpg", title: "Sacred Ritual" },
    { id: 10, img: "/assets/2.jpg", title: "Temple Decor" },
    { id: 11, img: "/assets/2.jpg", title: "Flower Offering" },
    { id: 12, img: "/assets/2.jpg", title: "Holy Atmosphere" },
];

export default galleryImages;